import React from 'react'

import { Image, Text } from "react-konva";
import useImage from "use-image";
import { size } from './consts'

const TemplateImage = (props) => {
  const [image, status] = useImage(props.image, "Anonymous");
  if (status === "loading") return <Text text={"Loading..."}></Text>;
  if (status === "failed") return <Text text={"ERROR!"}></Text>;
  return (
    <Image
      image={image}
      width={size.width}
      height={size.height}
      scaleX={props.scale || 1}
      scaleY={props.scale || 1}
    />
  );
};

export default TemplateImage;
